import React from "react"
import styled from "styled-components"

import { Box } from "components/box"
import { Paragraph } from "components/text"

const IconContainer = styled(Box).attrs({
  px: 4,
  ml: 1,
  bg: "melrose"
})`
  border-radius: 1.937rem;
  padding: 0.375rem 0.75rem;
`

const IconParagraph = styled(Paragraph)`
  font-size: 0.625rem;
  letter-spacing: 0.106rem;
`

const NewProductIcon = () => (
  <IconContainer>
    <IconParagraph bold>NEW</IconParagraph>
  </IconContainer>
)

export default NewProductIcon
